import React from 'react';
import { OverlayTrigger, Tooltip, OverlayTriggerProps } from 'react-bootstrap';

interface LomavisOverlayToolTip1Props {
  text: string;
  placement?: OverlayTriggerProps['placement']; // ✅ Type-safe placement
  children: React.ReactNode;
  show?: number;
  fromCard?: boolean;
  showTooltip?: boolean;
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
  /** Uses the white rounded helper-card treatment from Lomavis Creator. */
  creatorStyle?: boolean;
}

/**
 * LomavisOverlayToolTip1
 *
 * A wrapper component that shows a Bootstrap tooltip when the child element is hovered.
 *
 * Props:
 * - `text` (string): Tooltip content to display.
 * - `placement` (string): Position of the tooltip (e.g., 'top', 'right'). Defaults to 'top'.
 * - `children` (ReactNode): The element that will trigger the tooltip on hover or focus.
 */
export const LomavisOverlayToolTip1: React.FC<LomavisOverlayToolTip1Props> = ({
  text,
  placement = 'auto',
  children,
  show,
  fromCard = false,
  wrapperClassName = 'd-inline-block',
  wrapperStyle,
  showTooltip = true,
  creatorStyle = false
}) => {
  if (!showTooltip) {
    return <>{children}</>;
  }
  return (
    <OverlayTrigger
      delay={{ show, hide: 100 }}
      placement={placement}
      overlay={
        <Tooltip
          className={creatorStyle ? 'lomavis-creator-tooltip' : undefined}
        >
          <span
            className={`fw-bold d-block fs-7 text-start ${
              creatorStyle
                ? 'bg-white rounded shadow text-gray-600 px-3 py-2'
                : fromCard
                ? 'text-gray-800'
                : 'text-gray-400'
            } `}
            style={{ whiteSpace: fromCard && 'pre' }}
          >
            {text}
          </span>
        </Tooltip>
      }
    >
      <span className={wrapperClassName} style={wrapperStyle}>
        {children}
      </span>
    </OverlayTrigger>
  );
};
